import { makeStyles } from "@material-ui/core/styles";
import {useState} from 'react'
import Box from "@mui/material/Box";

import { MIcon, financeLogo } from "~/assets";
import { CategoryCard } from "../../../components";
import { marketing, business, trading, legal, tech, finance } from '~/assets';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';


export const Category = () => {
  const data = [
    {
      image: <img width={56} height={56} src={MIcon} alt="icon"></img>,
      subtitle: "Marketing",
      para: "Get a guided and personalized experience with access to theoretical knowledge, courses, mentoring program, guest talks, webinars, as well as practical knowledge through project opportunities and other bonus features.",
    },
    {
      image: <img width={56} height={56} src={financeLogo} alt="icon"></img>,
      subtitle: "Finance",
      para: "Explore and learn new topics based on profiled and unique learning paths. Each pathway merges different learning methods and opens up opportunities for every student at every level of study."
    },
    // {
    //   image: <img src={MIcon} alt="icon"></img>,
    //   subtitle: "Business",
    //   para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries. "
    // },
    // {
    //   image: <img src={MIcon} alt="icon"></img>,
    //   subtitle: "Trading",
    //   para: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words."
    // },
    // {
    //   image: <img src={MIcon} alt="icon"></img>,
    //   subtitle: "Tech",
    //   para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries."
    // },
    // {
    //   image: <img src={MIcon} alt="icon"></img>,
    //   subtitle: "Legal & Policy",
    //   para: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words."
    // },

  ];

  const [current, setCurrent] = useState({
      marketing: true,
      finance: false,
      business: false,
      trading: false,
      tech: false,
      legal: false,
  })

  const [content, setContent] = useState(data[0])

  // const handleChange = (chip: any, index: number) => {
  //   let tempCurrent = {
  //     marketing: false,
  //     finance: false,
  //     business: false,
  //     trading: false,
  //     tech: false,
  //     legal: false,
  //   }

  //   tempCurrent[chip] = true
  //   setCurrent(tempCurrent)
  //   setContent(data[index])
  // }
  


  return (

    

    <Box
    display="flex"
    flexDirection="column"
    // bgcolor="red"
    height="100%"
    justifyContent="space-between"
    >

    <Box overflow="hidden">
      <Box marginTop={5} maxWidth={{ xs: "100%", md: 700 }}
      display="flex"
      flexDirection="row"
      //@ts-ignore 
      flexWrap={{ md:"wrap", xs:"no-wrap"}}
      overflow={{xs:"scroll", md:"hidden"}}
      // style={{
      //   overflowX:"scroll"
      // }}
      >
        <Chip
          sx={{
            bgcolor: current.marketing? '#fff': '#141420',
            borderRadius: '15px',
            height:'57px',
            padding: 3,
            marginTop: 2,
            marginRight: '5px',         
          }}
          clickable={false}
          // onClick={() => handleChange('marketing',0)}
          avatar={<Avatar alt="Marketing" src={marketing} />}
          label={
            <Typography color={current.marketing? '#000':"#fff"} variant="subtitle1">
              Marketing
            </Typography>
          }
        />
        <Chip
          sx={{
            bgcolor: current.finance? '#fff': '#141420',
            borderRadius: '15px',
            height:'57px',
            marginRight: '5px',
            padding: 3,
            marginTop: 2,
          }}
          clickable={false}
          // onClick={() => handleChange('finance',1)}
          avatar={<Avatar alt="finance" src={finance} />}
          label={<Typography color={current.finance? '#000':"#fff"} variant="subtitle1">Finance</Typography>}
        />
        <Chip
          sx={{
            bgcolor: current.business? '#fff': '#141420',
            borderRadius: '15px',
            height:'57px',
            marginRight: '5px',
            padding: 3,
            marginTop: 2,
          }}
          clickable={false}
          // onClick={() => handleChange('business',2)}
          avatar={<Avatar alt="Business" src={business} />}
          label={<Typography color={current.business? '#000':"#fff"} variant="subtitle1">Business</Typography>}
        />
        <Chip
          sx={{
            bgcolor: current.trading? '#fff': '#141420',
            borderRadius: '15px',
            height:'57px',
            marginRight: '5px',
            padding: 3,
            marginTop: 2,
          }}
          clickable={false}
          // onClick={() => handleChange('trading',3)}
          avatar={<Avatar alt="trading" src={trading} />}
          label={<Typography color={current.trading? '#000':"#fff"} variant="subtitle1">Trading</Typography>}
        />
        <Chip
          sx={{
            bgcolor: current.tech? '#fff': '#141420',
            borderRadius: '15px',
            height:'57px',
            padding: 3,
            marginTop: 2,
            marginRight: '5px',
          }}
          clickable={false}
          // onClick={() => handleChange('tech',4)}
          avatar={<Avatar alt="tech" src={tech} />}
          label={<Typography color={current.tech? '#000':"#fff"} variant="subtitle1">Tech</Typography>}
        />
        <Chip
          sx={{
            bgcolor: current.legal? '#fff': '#141420',
            borderRadius: '15px',
            height:'57px',
            marginRight: '5px',
            padding: 3,
            marginTop: 2,
          }}
          clickable={false}
          // onClick={() => handleChange('legal',5)}
          avatar={<Avatar alt="legal" src={legal} />}
          label={<Typography color={current.legal? '#000':"#fff"} variant="subtitle1">Legal & Policy</Typography>}
        />
        <Chip
          label={<Typography variant="subtitle1">& more</Typography>}
          sx={{
            color: ' #FFFFFF',
            bgcolor: '#141420',
            borderRadius: '15px',
            height:'57px',
            marginRight: '5px',
            padding: 3,
            marginTop: 2,
          }}
        />
      </Box>
    </Box>


    <Box
        // marginLeft={10}
        marginTop={5}
        marginBottom={10}
        // bgcolor={"#141420"}
        // width={{ xs: "70%", md: "30%", lg: "30%" }}
        display="flex"
        //@ts-ignore 
        flexWrap='no-wrap'
        overflow={{md:'hidden', xs:'scroll' }}
        flexDirection={{ xs: "row", lg: "row" }}
        justifyContent={{ xs: "flex-start", md: "flex-start" }}
        alignItems="flex-start"
    >
        {data.map((item, index)=>{
          return (
            <Box marginRight={3} display='flex' flexDirection='row' justifyContent='center' alignItems='center' >
              <CategoryCard
                image={item.image}
                subtitle={item.subtitle}
                para={item.para}
                opacity={index==1? true: false}
              />
            </Box>
          )
        })}
            
          
        
    </Box>

    </Box>
  );
};
